// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Simple styling to get started */
body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background-color: #f8f9fa !important; /* A very light gray for the background */
  color: #212529; /* Dark text for readability */
  margin: 0;
}

.app-container {
  max-width: 1400px;
  margin: 2rem auto;
  padding: 0 1rem;
  padding-bottom: 120px; /* <-- ADD THIS LINE */
}

header {
  margin-bottom: 2rem;
}

.step-action-icons {
  position: absolute;
  bottom: -20px;
  right: 15px;
  display: flex;
  gap: 8px; /* Space between the two icons */
}

.indent-step-icon-btn, .outdent-step-icon-btn {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #8c959f; /* A neutral gray color */
  transition: color 0.2s ease;
}

.indent-step-icon-btn:hover, .outdent-step-icon-btn:hover {
  color: #007bff; /* Blue on hover */
}

.indent-step-icon-btn svg, .outdent-step-icon-btn svg {
  width: 22px;
  height: 22px;
}

/* Style for when the buttons are disabled */
.indent-step-icon-btn:disabled, .outdent-step-icon-btn:disabled {
  color: #d0d7de; /* A lighter gray */
  cursor: not-allowed;
}

/* --- Custom Tooltip Styles --- */
[data-tooltip] {
  position: relative; /* This is the anchor for the tooltip */
}

/* This creates the tooltip text */
[data-tooltip]::after {
  content: attr(data-tooltip); /* Use the attribute's value as the text */
  position: absolute;
  bottom: 100%; /* Position it above the button */
  left: 50%;
  transform: translateX(-50%);
  
  /* Styling */
  background-color: #343a40; /* Dark background */
  color: #ffffff;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap; /* Prevent the text from wrapping */
  
  /* Hide it by default */
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, visibility 0.2s ease;
  margin-bottom: 8px; /* Space between the button and the tooltip */
}

/* This shows the tooltip on hover */
[data-tooltip]:hover::after {
  opacity: 1;
  visibility: visible;
}

.remove-iteration-wrapper [data-tooltip]::after {
  left: 0;
  transform: translateX(0);
}

/* For the PLUS button on the far right, align the tooltip to the right */
.add-iteration-wrapper [data-tooltip]::after {
  left: auto;
  right: 0;
  transform: translateX(0);
}

.duplicate-step-icon-btn {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #8c959f; /* A neutral gray color */
  transition: color 0.2s ease;
}

.duplicate-step-icon-btn:hover {
  color: #007bff; /* Blue on hover */
}

.duplicate-step-icon-btn svg {
  width: 22px;
  height: 22px;
}

.add-step-icon-btn {
  /* Remove position, bottom, and right properties */
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #8c959f;
  transition: color 0.2s ease;
}
/* Keep the hover and svg styles for .add-step-icon-btn */

.add-step-icon-btn:hover {
  color: #454647; /* Blue on hover */
}

.add-step-icon-btn svg {
  width: 28px;
  height: 28px;
}

.add-step-icon-btn:hover {
  color: #007bff; /* Blue on hover */
}

.add-step-icon-btn svg {
  width: 22px;
  height: 22px;
}

.draggable-wrapper {
  position: relative;
  /* Add space below for the button to live in */
  margin-bottom: 30px; 
}

.add-step-icon-btn:hover {
  background-color: #0056b3;
}

.add-substep-btn {
  padding: 0.7rem 1.5rem;
  border: 1px solid transparent;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  transition: all 0.2s ease;
  background-color: #007bff; /* A different color (e.g., teal) */
  color: white;
}

.add-substep-btn:hover {
  background-color: #0069d9;
}

/* Add this new rule to App.css */
.action-group-left {
  display: flex;
  gap: 0.5rem; /* A smaller gap between the related buttons */
}

.problem-title {
  border: 1px solid #ccc;
  padding: 1rem;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  white-space: pre-wrap;
  /* The resize, overflow, and min-height properties have been removed */
}

.problem-title.expanded {
  max-height: 30rem;
}

.problem-title h3 {
  margin: 0;
  font-size: 1.1rem;
}

.problem-title p {
  margin-top: 0.75rem;
  margin-bottom: 0;
  color: #555;
  line-height: 1.5;
}

.thankyou-shell {
  text-align: center;
  padding: 4rem 1rem;
  max-width: 780px;
  margin: 0 auto;
}

.thankyou-actions {
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-top: 1.5rem;
}

.thankyou-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.85rem 1.25rem;
  border-radius: 8px;
  border: 1px solid #1f3b8f;
  font-weight: 600;
  text-decoration: none;
  color: #1f3b8f;
  background: #e8edff;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.thankyou-link.primary {
  background: #1f3b8f;
  color: #fff;
}

.thankyou-link:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(0,0,0,0.08);
}

/* Add this to App.css */
/* .step-row:focus-within {
  box-shadow: 0 0 8px rgba(0, 123, 255, 0.5);
} */

.drag-handle {
  cursor: grab;
  padding: 0 8px;
  display: flex;
  align-items: center;
}
.drag-handle:active {
  cursor: grabbing;
}


.step-container {
  flex: 1 1;
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  align-items: stretch;
  border-radius: 8px;
  transition: border-color 0.2s ease-in-out;
  background-color: #ffffff;
  
  /* --- Key Changes --- */
  border: 2px solid #dee2e6; /* A light gray border by default */
  outline: none; /* This REMOVES the ugly browser default highlight */
}

.delete-step-icon-btn {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #8c959f; /* A neutral gray color */
  transition: color 0.2s ease;
}

.delete-step-icon-btn:hover {
  color: #dc3545; /* Red on hover */
}

.delete-step-icon-btn svg {
  width: 22px;
  height: 22px;
}

.add-substep-icon-btn {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #8c959f; /* A neutral gray color */
  transition: color 0.2s ease;
}

.add-substep-icon-btn:hover {
  color: #007bff; /* Blue on hover */
}

.add-substep-icon-btn svg {
  width: 22px;
  height: 22px;
}

/* Add these new rules */
.step-row {
  display: flex;
  align-items: stretch;
  /* margin-bottom: 1rem; */
}

.indent-spacer {
  position: relative;
  flex-shrink: 0; /* Prevents the spacer from shrinking */
  transition: width 0.2s ease-in-out;
  display: flex;
  align-items: center;
}

.substep-indicator {
  position: absolute;
  right: 15px;
  top: 18px;
  color: #adb5bd;
}

.substep-indicator svg {
  width: 20px;
  height: 20px;
}

/* --- New Trace Variable Styles --- */
.trace-vars-container {
  flex: 1 1; /* This makes it take up all available space */
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  padding: 0; /* Padding is now on the parent */
  background-color: transparent; /* Parent has the background */
}

.trace-var-tag {
  display: flex;
  /* flex: 1; */
  align-items: center;
  background-color: #ffffff;
  border-radius: 16px; /* More rounded edges */
  padding: 4px 4px 4px 12px; /* Asymmetrical padding */
  border: 1px solid #d0d7de;
  box-shadow: 0 1px 2px rgba(0,0,0,0.04);
  transition: all 0.2s ease;
}



/* preserve the pill shape of .trace-var-tag */
.trace-var-tag {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border-radius: 16px;
  padding: 4px 8px;
  border: 1px solid #d0d7de;
  box-shadow: 0 1px 2px rgba(0,0,0,0.04);
  gap: 4px;
}

/* --- New Add Iteration Button Styles --- */
.add-iteration-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  padding-left: 10px;
  /* The 'gap' property is no longer needed */
}

.remove-iteration-btn {
  background: none;
  border: none;
  color: #6c757d; /* A neutral gray */
  font-size: 32px;
  font-weight: 300;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  transition: color 0.2s ease;
}

.remove-iteration-btn:hover {
  color: #343a40; /* Darker gray on hover */
}

.remove-iteration-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px; /* Give it a fixed space on the left */
  padding-right: 10px;
}

.add-iteration-btn {
  background: none;
  border: none;
  color: #6c757d; /* A neutral gray */
  font-size: 28px;
  font-weight: 300; /* A lighter plus sign */
  cursor: pointer;
  padding: 0;
  line-height: 1;
  transition: color 0.2s ease;
}

.add-iteration-btn:hover {
  color: #007bff; /* Blue on hover */
}

.trace-area {
  display: flex;
  align-items: center; /* Vertically aligns the vars and the button */
  background-color: #f8f9fa;
  padding: 12px;
}

.trace-var-input {
  background-color: #f6f8fa;
  border: 1px solid transparent;
  border-radius: 12px;
  height: 32px;
  padding: 0 10px;
  font-family: "SF Mono", "Consolas", "Courier New", monospace;
  font-weight: 500;
  transition: all 0.2s ease;
  box-sizing: border-box;
}

.trace-var-input:focus {
  outline: none;
  border-color: #0969da;
  background-color: #ffffff;
}

.trace-var-name {
  font-family: "SF Mono", "Consolas", "Courier New", monospace;
  font-weight: 600;
  font-size: 1rem;
  color: #57606a;
  margin-right: 8px;
}

.trace-var-name-input {
  /* Copied from .trace-var-input for consistent look */
  background-color: #f6f8fa; /* The gray background */
  border: 1px solid transparent;
  border-radius: 12px;
  height: 32px;
  padding: 0 10px;
  box-sizing: border-box;
  transition: all 0.2s ease;

  /* Kept from original name style */
  font-family: "SF Mono", "Consolas", monospace;
  font-weight: 600;
  font-size: 0.9rem; /* Adjusted for consistency */
  color: #000000;
  width: 80px; 
  outline: none;
}

/* --- New Output Box Styles --- */
/* .main-program-output-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 2rem; /* Add space above the output box */
  /* padding: 0 0.5rem; Align with the step containers */
/* } */ 

.program-output-label {
  font-weight: 500;
  font-size: 1rem;
  color: #495057;
}

.program-output-box {
  flex-grow: 1; /* Makes the box fill the remaining width */
  border: 1px solid #ced4da;
  border-radius: 6px;
  padding: 0.5rem 0.75rem;
  font-family: "SF Mono", "Consolas", "Courier New", monospace;
  font-size: 1rem;
  resize: vertical; /* Allow vertical resizing */
  background-color: #ffffff;
}

.trace-var-input:disabled {
  background-color: #e9ecef;
  color: #868e96;
  cursor: not-allowed;
}

.description-box {
  box-sizing: border-box;
  width: 100%;
  min-height: 80px; /* A smaller minimum height */
  padding: 1rem;
  border-radius: 8px 8px 0 0; /* Rounded corners only on top */
  border: none; /* The wrapper now has the border */
  border-bottom: 1px solid #dee2e6; /* A line to separate from vars */
  font-size: 1rem;
  resize: vertical;
  background-color: #ffffff;
  outline: none;
}

.trace-value-box {
  position: absolute;
  bottom: 10px; /* 10px from the bottom of the wrapper */
  left: 10px;   /* 10px from the left */
  right: 10px;  /* 10px from the right */

  box-sizing: border-box;
  height: 40px;
  padding: 0 10px;
  border: 1px solid #b0b0b0;
  border-radius: 6px;
  background-color: #e9ecef; /* Light gray from the diagram */
  font-family: "SF Mono", "Consolas", "Courier New", monospace;
  font-size: 1rem;
}

.main-program-input-container, .main-program-output-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  /* This aligns it with the right-hand column */
  max-width: 50%;
  margin-left: 50%;
  padding-right: 3rem;
  padding-left: 0.5rem; /* Corresponds to half the gap of .step-container */
  margin-bottom: 1rem;
  box-sizing: border-box; /* <-- ADD THIS LINE for perfect alignment */

}

.simulation-box {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  min-height: 100px;
  border-radius: 8px;
  border: 2px solid #e83e8c;
  resize: vertical;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  overflow-y: auto;
  background-color: #ffffff;
}

.variable-tag {
  background-color: #e9ecef;
  color: #000000;
  border-radius: 10px;
  padding: 6px 12px;
  margin-bottom: 8px;
  font-family: "SF Mono", "Consolas", "Courier New", monospace;
  font-size: 0.95rem;
  font-weight: bold;
  width: fit-content;
  text-align: center;
  transition: background-color 0.2s ease, border-color 0.2s ease;
  cursor: pointer;
}

.variable-tag.selected {
  background-color: #d1e7fd;
  border-color: #0d6efd;
}

.variable-tag:last-child {
  margin-bottom: 0;
}

.variable-tag-editor {
  background-color: white;
  border: 2px solid #0d6efd;
  /* Blue border to show it's active */
  border-radius: 10px;
  padding: 6px 12px;
  margin-bottom: 8px;
  font-family: "SF Mono", "Consolas", "Courier New", monospace;
  font-size: 0.95rem;
  width: fit-content;
  min-width: 160px;
  /* Give it a minimum width */
  text-align: center;
  outline: none;
}

.chat-box {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  width: 550px;
  height: 600px;
  background-color: #ddd;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 1000;
  resize: both;
  overflow: auto;
}

.chat-box.draggable {
  transform: none;
}



.chat-header {
  padding: 0.75rem 1rem;
  font-weight: bold;
  background: linear-gradient(to right, #6a11cb, #2575fc);
  color: white;
  border-bottom: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.close-chat {
  font-size: 1.2rem;
  border: none;
  background: transparent;
  color: white;
  cursor: pointer;
  margin-left: auto;
}

.chat-messages {
  flex: 1 1;
  padding: 1rem;
  padding-bottom: 5rem;
  /* Add extra space at the bottom */
  overflow-y: auto;
  background: #f6f6f6;
  display: flex;
  flex-direction: column;
}

.chat-message {
  max-width: 75%;
  padding: 0.6rem 1rem;
  margin-bottom: 0.6rem;
  border-radius: 16px;
  font-size: 0.95rem;
  line-height: 1.4;
  word-wrap: break-word;
}

.chat-message.user {
  background-color: #6a11cb;
  color: white;
  align-self: flex-end;
  border-bottom-right-radius: 0;
}

.chat-message.bot {
  background-color: #f0f0f0;
  color: #333;
  align-self: flex-start;
  border-bottom-left-radius: 0;
}

.chat-input-container {
  display: flex;
  border-top: 1px solid #ccc;
  padding: 0.5rem;
  background-color: #fff;
}

.chat-input {
  flex: 1 1;
  border: 1px solid #ccc;
  padding: 0.6rem 1rem;
  font-size: 1rem;
  border-radius: 6px;
  margin-right: 0.5rem;
}

.chat-next-btn, .chat-retry-btn {
  position: absolute;
  bottom: 4rem;
  /* Position it 4rem from the bottom of the chat box */
  right: 1rem;
  z-index: 10;
  /* Ensure it's on top of the messages */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);

  /* Visual styles */
  background-color: #2575fc;
  color: white;
  border: none;
  padding: 0.5rem 0.8rem;
  font-size: 0.9rem;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.chat-next-btn:hover, .chat-retry-btn:hover {
  background-color: #138496;
}

.chat-next-btn:disabled, .chat-retry-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  box-shadow: none;
}

/* This is the existing rule for the disabled button */
.refine-btn.disabled,.tests-btn.disabled {
  background-color: #e9ecef;
  border-color: #ced4da;
  color: #6c757d;
  cursor: not-allowed;
}

.notification-banner {
  position: fixed;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  padding: 1rem 1.5rem;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  display: flex;
  align-items: center;
  gap: 1rem;
  z-index: 2000;
  font-size: 1rem;
  border: 1px solid transparent;
}

.notification-banner.warning {
  background-color: #fff3cd;
  border-color: #ffeeba;
  color: #856404;
}

.notification-close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  color: inherit;
  opacity: 0.7;
}
.notification-close-btn:hover {
  opacity: 1;
}

.chat-send {
  background-color: #2575fc;
  color: white;
  border: none;
  padding: 0.6rem 1rem;
  font-size: 1rem;
  border-radius: 6px;
  cursor: pointer;
}

/* .add-step-btn,
.delete-step-btn {
  padding: 0.7rem 1.5rem;
  border: 1px solid transparent;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  transition: all 0.2s ease;
  background-color: #007bff; /* Red color */
  /* color: white;
}

.add-step-btn,
.delete-step-btn:hover {
  background-color: #007bff;
}

.delete-step-btn:disabled {
  background-color: #e9ecef;
  border-color: #ced4da;
  color: #6c757d;
  cursor: not-allowed;
} */ 


/* .step-container.selected-step {
  border-color: #000000; /* Blue border to indicate selection */
  /* box-shadow: 0 0 0 8px rgba(0, 0, 0, 0.25); */
/* } */ 

/* When a step is selected, change the background of the description box */
/* .step-container.selected .description-box { */
  /* background-color: #e7f3ff; Light pastel blue */
  /* border-color: #b3d7ff;      */
/* } */

/* Also change the background of the simulation box */
/* .step-container.selected .simulation-box { */
  /* background-color: #e7f3ff; Light pastel blue */
  /* border-color: #b3d7ff;     */
/* } */

.step-container.selected {
  border-color: #0d6efd; /* A standard red color */
}

/* New style for correctly verified steps */
/* --- Verification Status Styles (Corrected) --- */

/* Style for CORRECT steps */
.step-container.correct .description-wrapper {
  background-color: #d4edda; /* Light pastel green */
  border-color: #c3e6cb;
}
.step-container.correct .description-box,
.step-container.correct .trace-area {
  background-color: transparent; /* Make children transparent */
}


/* Style for INCORRECT steps */
.step-container.incorrect .description-wrapper {
  background-color: #f8d7da; /* Light pastel red */
  border-color: #f5c6cb;
}
.step-container.incorrect .description-box,
.step-container.incorrect .trace-area {
  background-color: transparent; /* Make children transparent */
}

/* New style for the green success notification */
.notification-banner.success {
  background-color: #d4edda;
  border-color: #c3e6cb;
  color: #155724;
}

/* --- Container for top-left buttons --- */
/* This new rule handles the sticky behavior */
.sticky-actions-bar {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: #f8f9fa;
  padding: 1rem 0; /* Vertical padding */
  margin-bottom: 1.5rem; /* Space below the bar */
  /* box-shadow: 0 2px 8px rgba(0,0,0,0.07); */
}

/* --- New Iteration Row Styles --- */
.iteration-rows-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 8px 0; /* Add some vertical padding */
}

.iteration-row-wrapper {
  display: flex;
  width: 100%;
  align-items: center;
  margin-bottom: 8px; /* <-- Add this line */
}

/* This targets the first iteration row and adds a separator below it */
.iteration-row:first-child {
  padding-bottom: 12px; /* Space below the row */
  margin-bottom: 12px;  /* More space */
  border-bottom: 1px dashed #adb5bd; /* A dashed separator line */
}

.iteration-row {
  flex: 1 1; /* This makes the row of variables take up the available space */
  display: flex;
  justify-content: center;
  gap: 10px;
  /* margin-bottom: 8px; */
}

/* This adds a separator line between iteration rows */
.iteration-row-wrapper + .iteration-row-wrapper {
  border-top: 1px dashed #adb5bd;
  padding-top: 12px; /* Space after the line, before the next row */
  margin-top: 12px;  /* More space */
}

/* This rule just handles the button layout inside the bar */
.actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* We need to constrain the width to match the main content */
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 1rem;
}

/* --- New styles for the footer bar --- */
.footer-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #ffffff;
  padding: 1rem;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between; /* This is the key change */
  align-items: center;
  z-index: 1000;
  padding-bottom: 40px;
}

.submit-btn {

  /* The original visual styles are kept */
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.8rem 1.5rem;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15); /* Adds a subtle shadow to lift it off the page */
}

/* Add these new rules anywhere in App.css */
.footer-spacer, .footer-center-group, .footer-right-group {
  flex: 1 1; /* Each column takes up 1/3 of the space */
}

.footer-center-group {
  display: flex;
  justify-content: center; /* Center the buttons within this column */
  gap: 1.5rem;
}

.footer-right-group {
  display: flex;
  justify-content: flex-end; /* Push the button to the right of this column */
  padding-right: 5rem;
}

.submit-btn:hover {
  background-color: #218838;
}

/* --- Confirmation Modal Styles --- */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6); /* Semi-transparent black background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000; /* Ensure it's on top of everything */
}

.modal-content {
  background-color: #ffffff;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  text-align: center;
  max-width: 450px;
}

.modal-content h3 {
  margin-top: 0;
  font-size: 1.5rem;
}

.modal-content p {
  margin-bottom: 2rem;
  color: #6c757d;
}

.modal-actions {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.modal-cancel-btn, .modal-confirm-btn {
  padding: 0.7rem 1.5rem;
  border: 1px solid transparent;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  transition: all 0.2s ease;
}

.modal-cancel-btn {
  background-color: #6c757d;
  color: white;
}
.modal-cancel-btn:hover {
  background-color: #5a6268;
}

.description-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column; /* Stack children vertically */
  border: 2px solid #dee2e6;
  border-radius: 8px;
  background-color: #ffffff;
  overflow: hidden; /* Ensures children stay within the rounded corners */
}

.step-feedback-banner {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem;
  background: #ffe8e8;
  color: #7a1414;
  border-top: 1px solid #f2b2b2;
  padding: 0.6rem 0.9rem;
  font-size: 0.9rem;
  line-height: 1.4;
  font-weight: 500;
}

.step-feedback-text {
  flex: 1 1;
}

.step-container.incorrect .step-feedback-banner {
  background: #fee2e2;
}

.feedback-actions {
  display: inline-flex;
  gap: 0.35rem;
  align-items: center;
}

.feedback-vote-btn {
  border: none;
  background: #f8f9fa;
  border-radius: 6px;
  padding: 0.25rem 0.5rem;
  cursor: pointer;
  font-size: 1.1rem;
  line-height: 1;
}

.feedback-vote-btn:hover,
.feedback-vote-btn:focus-visible {
  background: #e9ecef;
}

.feedback-vote-btn.selected.up {
  background: #d1e7dd;
  color: #0f5132;
}

.feedback-vote-btn.selected.down {
  background: #f8d7da;
  color: #842029;
}

.feedback-dismiss-btn {
  flex-shrink: 0;
  border: none;
  background: transparent;
  color: #7a1414;
  font-weight: 600;
  cursor: pointer;
  padding: 0.1rem 0.4rem;
  line-height: 1;
  border-radius: 4px;
}

.feedback-dismiss-btn:hover,
.feedback-dismiss-btn:focus-visible {
  background: rgba(0, 0, 0, 0.05);
  outline: none;
}

.modal-confirm-btn {
  background-color: #dc3545; /* Red to indicate a final action */
  color: white;
}
.modal-confirm-btn:hover {
  background-color: #c82333;
}

.verify-btn {
  padding: 0.8rem 1.5rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
}

/* .add-step-btn:hover {
  background-color: #c82333;
} */

.verify-btn {
  background-color: #28a745;
  color: white;
}

.tests-btn,
.refine-btn {
  padding: 0.8rem 1.5rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  background-color: #28a745;
  /* teal/blue shade */
  color: white;
}


.add-var-button {
  position: absolute;
  bottom: 12px;
  right: 12px;
  width: 32px;
  height: 32px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}

.delete-var-button:disabled {
  background-color: #e9ecef;
  border-color: #ced4da;
  color: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.add-var-button:hover {
  background-color: #0056b3;
}

.delete-var-button {
  position: absolute;
  bottom: 12px;
  left: 12px;
  width: 32px;
  height: 32px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}

.delete-var-button:hover {
  background-color: #007bff;
}

.simulation-wrapper {
  width: 50%;
  position: relative;
  display: flex;
  justify-content: center; /* Re-center its content */
  align-items: center;
  /* \`flex-direction: column\` and \`gap\` are no longer needed here */
}

.program-input-area {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

/* Style for the "Input" text label */
.program-input-label {
  font-weight: 500;
  font-size: 1rem;
  color: #495057;
}

/* Style for the new input text box */
.program-input-box {
  flex-grow: 1; /* Makes the box fill the remaining width */
  border: 1px solid #ced4da;
  border-radius: 6px;
  padding: 0.5rem 0.75rem;
  font-family: "SF Mono", "Consolas", "Courier New", monospace;
  font-size: 1rem;
  resize: none; /* Disables the user's ability to resize it */
}

/* --- Loading Spinner Styles --- */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7); /* Semi-transparent white background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3000; /* Ensure it's on top of everything */
}

.spinner {
  width: 60px;
  height: 60px;
  border: 8px solid #f3f3f3; /* Light grey circle */
  border-top: 8px solid #3498db; /* Blue for the spinning part */
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.delete-step-icon-btn.disabled,
.delete-step-icon-btn:disabled {
  opacity: 0.4;          /* faded gray */
  cursor: not-allowed;   /* blocked cursor */
  pointer-events: none;  /* no clicks */
}

.disclaimer-footer {
  position: absolute; /* Position it relative to the .footer-actions */
  bottom: 6px; /* A small margin from the bottom of the footer */
  left: 0;
  width: 100%;
  color: #6c757d; /* A lighter gray for less emphasis */
  text-align: center;
  font-size: 0.75rem;
  /* font-style: italic; */
}

.example-footer {
  display: flex;
  justify-content: center;
  margin: 2rem 0;
}

.example-continue-btn {
  background-color: #28a745;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0.85rem 2.5rem;
  font-size: 1rem;
  cursor: pointer;
}

.example-continue-btn:hover {
  background-color: #218838;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,uGAAuG;EACvG,oCAAoC,EAAE,yCAAyC;EAC/E,cAAc,EAAE,8BAA8B;EAC9C,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,qBAAqB,EAAE,sBAAsB;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,aAAa;EACb,QAAQ,EAAE,gCAAgC;AAC5C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,cAAc,EAAE,yBAAyB;EACzC,2BAA2B;AAC7B;;AAEA;EACE,cAAc,EAAE,kBAAkB;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,4CAA4C;AAC5C;EACE,cAAc,EAAE,mBAAmB;EACnC,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB,EAAE,uCAAuC;AAC7D;;AAEA,kCAAkC;AAClC;EACE,2BAA2B,EAAE,0CAA0C;EACvE,kBAAkB;EAClB,YAAY,EAAE,iCAAiC;EAC/C,SAAS;EACT,2BAA2B;;EAE3B,YAAY;EACZ,yBAAyB,EAAE,oBAAoB;EAC/C,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB,EAAE,mCAAmC;;EAExD,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,mDAAmD;EACnD,kBAAkB,EAAE,6CAA6C;AACnE;;AAEA,oCAAoC;AACpC;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,wBAAwB;AAC1B;;AAEA,yEAAyE;AACzE;EACE,UAAU;EACV,QAAQ;EACR,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,cAAc,EAAE,yBAAyB;EACzC,2BAA2B;AAC7B;;AAEA;EACE,cAAc,EAAE,kBAAkB;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,cAAc;EACd,2BAA2B;AAC7B;AACA,yDAAyD;;AAEzD;EACE,cAAc,EAAE,kBAAkB;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc,EAAE,kBAAkB;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB,EAAE,mCAAmC;EAC9D,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,WAAW,EAAE,8CAA8C;AAC7D;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,sCAAsC;EACtC,qBAAqB;EACrB,sEAAsE;AACxE;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA,wBAAwB;AACxB;;GAEG;;AAEH;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;;AAGA;EACE,SAAO;EACP,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;;EAEzB,wBAAwB;EACxB,yBAAyB,EAAE,mCAAmC;EAC9D,aAAa,EAAE,oDAAoD;AACrE;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,cAAc,EAAE,yBAAyB;EACzC,2BAA2B;AAC7B;;AAEA;EACE,cAAc,EAAE,iBAAiB;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,cAAc,EAAE,yBAAyB;EACzC,2BAA2B;AAC7B;;AAEA;EACE,cAAc,EAAE,kBAAkB;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc,EAAE,uCAAuC;EACvD,kCAAkC;EAClC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,sCAAsC;AACtC;EACE,SAAO,EAAE,8CAA8C;EACvD,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,UAAU,EAAE,iCAAiC;EAC7C,6BAA6B,EAAE,8BAA8B;AAC/D;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB,EAAE,uBAAuB;EAC5C,yBAAyB,EAAE,yBAAyB;EACpD,yBAAyB;EACzB,sCAAsC;EACtC,yBAAyB;AAC3B;;;;AAIA,8CAA8C;AAC9C;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sCAAsC;EACtC,QAAQ;AACV;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc,EAAE,mBAAmB;EACnC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc,EAAE,yBAAyB;AAC3C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW,EAAE,sCAAsC;EACnD,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc,EAAE,mBAAmB;EACnC,eAAe;EACf,gBAAgB,EAAE,wBAAwB;EAC1C,eAAe;EACf,UAAU;EACV,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc,EAAE,kBAAkB;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,8CAA8C;EACnE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,4DAA4D;EAC5D,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,4DAA4D;EAC5D,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qDAAqD;EACrD,yBAAyB,EAAE,wBAAwB;EACnD,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,yBAAyB;;EAEzB,kCAAkC;EAClC,6CAA6C;EAC7C,gBAAgB;EAChB,iBAAiB,EAAE,6BAA6B;EAChD,cAAc;EACd,WAAW;EACX,aAAa;AACf;;AAEA,kCAAkC;AAClC;;;;uDAIuD;EACrD,sDAAsD;AACxD,MAAM;;AAEN;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY,EAAE,2CAA2C;EACzD,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,4DAA4D;EAC5D,eAAe;EACf,gBAAgB,EAAE,4BAA4B;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB,EAAE,6BAA6B;EAC/C,aAAa;EACb,0BAA0B,EAAE,gCAAgC;EAC5D,YAAY,EAAE,mCAAmC;EACjD,gCAAgC,EAAE,iCAAiC;EACnE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY,EAAE,wCAAwC;EACtD,UAAU,IAAI,uBAAuB;EACrC,WAAW,GAAG,wBAAwB;;EAEtC,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB,EAAE,gCAAgC;EAC3D,4DAA4D;EAC5D,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8CAA8C;EAC9C,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB,EAAE,mDAAmD;EACzE,mBAAmB;EACnB,sBAAsB,EAAE,4CAA4C;;AAEtE;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,4DAA4D;EAC5D,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,8DAA8D;EAC9D,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,4DAA4D;EAC5D,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;;;AAIA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,uDAAuD;EACvD,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,oBAAoB;EACpB,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,qDAAqD;EACrD,WAAW;EACX,WAAW;EACX,uCAAuC;EACvC,wCAAwC;;EAExC,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;EAClB,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;EACd,YAAY;AACd;AACA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;;;;;;;2CAS2C;EACzC;;;;;;;;;;;;;GAaC;;;AAGH;+DAC+D;EAC7D,+CAA+C;AACjD,MAAM;;AAEN,0EAA0E;AAC1E,gDAAgD;EAC9C,iDAAiD;EACjD,gCAAgC;AAClC,MAAM;;AAEN,qDAAqD;AACrD,+CAA+C;EAC7C,iDAAiD;EACjD,+BAA+B;AACjC,MAAM;;AAEN;EACE,qBAAqB,EAAE,yBAAyB;AAClD;;AAEA,2CAA2C;AAC3C,mDAAmD;;AAEnD,4BAA4B;AAC5B;EACE,yBAAyB,EAAE,uBAAuB;EAClD,qBAAqB;AACvB;AACA;;EAEE,6BAA6B,EAAE,8BAA8B;AAC/D;;;AAGA,8BAA8B;AAC9B;EACE,yBAAyB,EAAE,qBAAqB;EAChD,qBAAqB;AACvB;AACA;;EAEE,6BAA6B,EAAE,8BAA8B;AAC/D;;AAEA,iDAAiD;AACjD;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,2CAA2C;AAC3C,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,yBAAyB;EACzB,eAAe,EAAE,qBAAqB;EACtC,qBAAqB,EAAE,wBAAwB;EAC/C,4CAA4C;AAC9C;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,cAAc,EAAE,8BAA8B;AAChD;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,kBAAkB,EAAE,sBAAsB;AAC5C;;AAEA,uEAAuE;AACvE;EACE,oBAAoB,EAAE,wBAAwB;EAC9C,mBAAmB,GAAG,eAAe;EACrC,iCAAiC,EAAE,4BAA4B;AACjE;;AAEA;EACE,SAAO,EAAE,gEAAgE;EACzE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,wBAAwB;AAC1B;;AAEA,sDAAsD;AACtD;EACE,8BAA8B;EAC9B,iBAAiB,EAAE,8CAA8C;EACjE,gBAAgB,GAAG,eAAe;AACpC;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6DAA6D;EAC7D,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,8BAA8B,EAAE,2BAA2B;EAC3D,mBAAmB;EACnB,aAAa;EACb,oBAAoB;AACtB;;AAEA;;EAEE,wCAAwC;EACxC,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,uCAAuC,EAAE,iDAAiD;AAC5F;;AAEA,4CAA4C;AAC5C;EACE,SAAO,EAAE,0CAA0C;AACrD;;AAEA;EACE,aAAa;EACb,uBAAuB,EAAE,0CAA0C;EACnE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB,EAAE,gDAAgD;EAC3E,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC,EAAE,sCAAsC;EAC5E,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,qCAAqC;AACtD;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB,EAAE,8BAA8B;EACtD,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB,EAAE,qDAAqD;AACzE;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,6BAA6B;EAC7B,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,yBAAyB,EAAE,mCAAmC;EAC9D,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;;GAEG;;AAEH;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,YAAY;AACd;;;AAGA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,uBAAuB,EAAE,0BAA0B;EACnD,mBAAmB;EACnB,iEAAiE;AACnE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,YAAY,EAAE,2CAA2C;EACzD,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,4DAA4D;EAC5D,eAAe;EACf,YAAY,EAAE,6CAA6C;AAC7D;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,0CAA0C,EAAE,sCAAsC;EAClF,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,qCAAqC;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB,EAAE,sBAAsB;EACjD,6BAA6B,EAAE,+BAA+B;EAC9D,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;;EAEE,YAAY,WAAW,eAAe;EACtC,mBAAmB,IAAI,mBAAmB;EAC1C,oBAAoB,GAAG,cAAc;AACvC;;AAEA;EACE,kBAAkB,EAAE,gDAAgD;EACpE,WAAW,EAAE,iDAAiD;EAC9D,OAAO;EACP,WAAW;EACX,cAAc,EAAE,qCAAqC;EACrD,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* Simple styling to get started */\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n  background-color: #f8f9fa !important; /* A very light gray for the background */\n  color: #212529; /* Dark text for readability */\n  margin: 0;\n}\n\n.app-container {\n  max-width: 1400px;\n  margin: 2rem auto;\n  padding: 0 1rem;\n  padding-bottom: 120px; /* <-- ADD THIS LINE */\n}\n\nheader {\n  margin-bottom: 2rem;\n}\n\n.step-action-icons {\n  position: absolute;\n  bottom: -20px;\n  right: 15px;\n  display: flex;\n  gap: 8px; /* Space between the two icons */\n}\n\n.indent-step-icon-btn, .outdent-step-icon-btn {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  color: #8c959f; /* A neutral gray color */\n  transition: color 0.2s ease;\n}\n\n.indent-step-icon-btn:hover, .outdent-step-icon-btn:hover {\n  color: #007bff; /* Blue on hover */\n}\n\n.indent-step-icon-btn svg, .outdent-step-icon-btn svg {\n  width: 22px;\n  height: 22px;\n}\n\n/* Style for when the buttons are disabled */\n.indent-step-icon-btn:disabled, .outdent-step-icon-btn:disabled {\n  color: #d0d7de; /* A lighter gray */\n  cursor: not-allowed;\n}\n\n/* --- Custom Tooltip Styles --- */\n[data-tooltip] {\n  position: relative; /* This is the anchor for the tooltip */\n}\n\n/* This creates the tooltip text */\n[data-tooltip]::after {\n  content: attr(data-tooltip); /* Use the attribute's value as the text */\n  position: absolute;\n  bottom: 100%; /* Position it above the button */\n  left: 50%;\n  transform: translateX(-50%);\n  \n  /* Styling */\n  background-color: #343a40; /* Dark background */\n  color: #ffffff;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  white-space: nowrap; /* Prevent the text from wrapping */\n  \n  /* Hide it by default */\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.2s ease, visibility 0.2s ease;\n  margin-bottom: 8px; /* Space between the button and the tooltip */\n}\n\n/* This shows the tooltip on hover */\n[data-tooltip]:hover::after {\n  opacity: 1;\n  visibility: visible;\n}\n\n.remove-iteration-wrapper [data-tooltip]::after {\n  left: 0;\n  transform: translateX(0);\n}\n\n/* For the PLUS button on the far right, align the tooltip to the right */\n.add-iteration-wrapper [data-tooltip]::after {\n  left: auto;\n  right: 0;\n  transform: translateX(0);\n}\n\n.duplicate-step-icon-btn {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  color: #8c959f; /* A neutral gray color */\n  transition: color 0.2s ease;\n}\n\n.duplicate-step-icon-btn:hover {\n  color: #007bff; /* Blue on hover */\n}\n\n.duplicate-step-icon-btn svg {\n  width: 22px;\n  height: 22px;\n}\n\n.add-step-icon-btn {\n  /* Remove position, bottom, and right properties */\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  color: #8c959f;\n  transition: color 0.2s ease;\n}\n/* Keep the hover and svg styles for .add-step-icon-btn */\n\n.add-step-icon-btn:hover {\n  color: #454647; /* Blue on hover */\n}\n\n.add-step-icon-btn svg {\n  width: 28px;\n  height: 28px;\n}\n\n.add-step-icon-btn:hover {\n  color: #007bff; /* Blue on hover */\n}\n\n.add-step-icon-btn svg {\n  width: 22px;\n  height: 22px;\n}\n\n.draggable-wrapper {\n  position: relative;\n  /* Add space below for the button to live in */\n  margin-bottom: 30px; \n}\n\n.add-step-icon-btn:hover {\n  background-color: #0056b3;\n}\n\n.add-substep-btn {\n  padding: 0.7rem 1.5rem;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  background-color: #007bff; /* A different color (e.g., teal) */\n  color: white;\n}\n\n.add-substep-btn:hover {\n  background-color: #0069d9;\n}\n\n/* Add this new rule to App.css */\n.action-group-left {\n  display: flex;\n  gap: 0.5rem; /* A smaller gap between the related buttons */\n}\n\n.problem-title {\n  border: 1px solid #ccc;\n  padding: 1rem;\n  border-radius: 8px;\n  background-color: white;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.05);\n  white-space: pre-wrap;\n  /* The resize, overflow, and min-height properties have been removed */\n}\n\n.problem-title.expanded {\n  max-height: 30rem;\n}\n\n.problem-title h3 {\n  margin: 0;\n  font-size: 1.1rem;\n}\n\n.problem-title p {\n  margin-top: 0.75rem;\n  margin-bottom: 0;\n  color: #555;\n  line-height: 1.5;\n}\n\n.thankyou-shell {\n  text-align: center;\n  padding: 4rem 1rem;\n  max-width: 780px;\n  margin: 0 auto;\n}\n\n.thankyou-actions {\n  display: flex;\n  justify-content: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  margin-top: 1.5rem;\n}\n\n.thankyou-link {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.85rem 1.25rem;\n  border-radius: 8px;\n  border: 1px solid #1f3b8f;\n  font-weight: 600;\n  text-decoration: none;\n  color: #1f3b8f;\n  background: #e8edff;\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.thankyou-link.primary {\n  background: #1f3b8f;\n  color: #fff;\n}\n\n.thankyou-link:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 18px rgba(0,0,0,0.08);\n}\n\n/* Add this to App.css */\n/* .step-row:focus-within {\n  box-shadow: 0 0 8px rgba(0, 123, 255, 0.5);\n} */\n\n.drag-handle {\n  cursor: grab;\n  padding: 0 8px;\n  display: flex;\n  align-items: center;\n}\n.drag-handle:active {\n  cursor: grabbing;\n}\n\n\n.step-container {\n  flex: 1;\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  align-items: stretch;\n  border-radius: 8px;\n  transition: border-color 0.2s ease-in-out;\n  background-color: #ffffff;\n  \n  /* --- Key Changes --- */\n  border: 2px solid #dee2e6; /* A light gray border by default */\n  outline: none; /* This REMOVES the ugly browser default highlight */\n}\n\n.delete-step-icon-btn {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  color: #8c959f; /* A neutral gray color */\n  transition: color 0.2s ease;\n}\n\n.delete-step-icon-btn:hover {\n  color: #dc3545; /* Red on hover */\n}\n\n.delete-step-icon-btn svg {\n  width: 22px;\n  height: 22px;\n}\n\n.add-substep-icon-btn {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  color: #8c959f; /* A neutral gray color */\n  transition: color 0.2s ease;\n}\n\n.add-substep-icon-btn:hover {\n  color: #007bff; /* Blue on hover */\n}\n\n.add-substep-icon-btn svg {\n  width: 22px;\n  height: 22px;\n}\n\n/* Add these new rules */\n.step-row {\n  display: flex;\n  align-items: stretch;\n  /* margin-bottom: 1rem; */\n}\n\n.indent-spacer {\n  position: relative;\n  flex-shrink: 0; /* Prevents the spacer from shrinking */\n  transition: width 0.2s ease-in-out;\n  display: flex;\n  align-items: center;\n}\n\n.substep-indicator {\n  position: absolute;\n  right: 15px;\n  top: 18px;\n  color: #adb5bd;\n}\n\n.substep-indicator svg {\n  width: 20px;\n  height: 20px;\n}\n\n/* --- New Trace Variable Styles --- */\n.trace-vars-container {\n  flex: 1; /* This makes it take up all available space */\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 12px;\n  padding: 0; /* Padding is now on the parent */\n  background-color: transparent; /* Parent has the background */\n}\n\n.trace-var-tag {\n  display: flex;\n  /* flex: 1; */\n  align-items: center;\n  background-color: #ffffff;\n  border-radius: 16px; /* More rounded edges */\n  padding: 4px 4px 4px 12px; /* Asymmetrical padding */\n  border: 1px solid #d0d7de;\n  box-shadow: 0 1px 2px rgba(0,0,0,0.04);\n  transition: all 0.2s ease;\n}\n\n\n\n/* preserve the pill shape of .trace-var-tag */\n.trace-var-tag {\n  display: flex;\n  align-items: center;\n  background-color: #ffffff;\n  border-radius: 16px;\n  padding: 4px 8px;\n  border: 1px solid #d0d7de;\n  box-shadow: 0 1px 2px rgba(0,0,0,0.04);\n  gap: 4px;\n}\n\n/* --- New Add Iteration Button Styles --- */\n.add-iteration-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  padding-left: 10px;\n  /* The 'gap' property is no longer needed */\n}\n\n.remove-iteration-btn {\n  background: none;\n  border: none;\n  color: #6c757d; /* A neutral gray */\n  font-size: 32px;\n  font-weight: 300;\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n  transition: color 0.2s ease;\n}\n\n.remove-iteration-btn:hover {\n  color: #343a40; /* Darker gray on hover */\n}\n\n.remove-iteration-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px; /* Give it a fixed space on the left */\n  padding-right: 10px;\n}\n\n.add-iteration-btn {\n  background: none;\n  border: none;\n  color: #6c757d; /* A neutral gray */\n  font-size: 28px;\n  font-weight: 300; /* A lighter plus sign */\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n  transition: color 0.2s ease;\n}\n\n.add-iteration-btn:hover {\n  color: #007bff; /* Blue on hover */\n}\n\n.trace-area {\n  display: flex;\n  align-items: center; /* Vertically aligns the vars and the button */\n  background-color: #f8f9fa;\n  padding: 12px;\n}\n\n.trace-var-input {\n  background-color: #f6f8fa;\n  border: 1px solid transparent;\n  border-radius: 12px;\n  height: 32px;\n  padding: 0 10px;\n  font-family: \"SF Mono\", \"Consolas\", \"Courier New\", monospace;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  box-sizing: border-box;\n}\n\n.trace-var-input:focus {\n  outline: none;\n  border-color: #0969da;\n  background-color: #ffffff;\n}\n\n.trace-var-name {\n  font-family: \"SF Mono\", \"Consolas\", \"Courier New\", monospace;\n  font-weight: 600;\n  font-size: 1rem;\n  color: #57606a;\n  margin-right: 8px;\n}\n\n.trace-var-name-input {\n  /* Copied from .trace-var-input for consistent look */\n  background-color: #f6f8fa; /* The gray background */\n  border: 1px solid transparent;\n  border-radius: 12px;\n  height: 32px;\n  padding: 0 10px;\n  box-sizing: border-box;\n  transition: all 0.2s ease;\n\n  /* Kept from original name style */\n  font-family: \"SF Mono\", \"Consolas\", monospace;\n  font-weight: 600;\n  font-size: 0.9rem; /* Adjusted for consistency */\n  color: #000000;\n  width: 80px; \n  outline: none;\n}\n\n/* --- New Output Box Styles --- */\n/* .main-program-output-container {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-top: 2rem; /* Add space above the output box */\n  /* padding: 0 0.5rem; Align with the step containers */\n/* } */ \n\n.program-output-label {\n  font-weight: 500;\n  font-size: 1rem;\n  color: #495057;\n}\n\n.program-output-box {\n  flex-grow: 1; /* Makes the box fill the remaining width */\n  border: 1px solid #ced4da;\n  border-radius: 6px;\n  padding: 0.5rem 0.75rem;\n  font-family: \"SF Mono\", \"Consolas\", \"Courier New\", monospace;\n  font-size: 1rem;\n  resize: vertical; /* Allow vertical resizing */\n  background-color: #ffffff;\n}\n\n.trace-var-input:disabled {\n  background-color: #e9ecef;\n  color: #868e96;\n  cursor: not-allowed;\n}\n\n.description-box {\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 80px; /* A smaller minimum height */\n  padding: 1rem;\n  border-radius: 8px 8px 0 0; /* Rounded corners only on top */\n  border: none; /* The wrapper now has the border */\n  border-bottom: 1px solid #dee2e6; /* A line to separate from vars */\n  font-size: 1rem;\n  resize: vertical;\n  background-color: #ffffff;\n  outline: none;\n}\n\n.trace-value-box {\n  position: absolute;\n  bottom: 10px; /* 10px from the bottom of the wrapper */\n  left: 10px;   /* 10px from the left */\n  right: 10px;  /* 10px from the right */\n\n  box-sizing: border-box;\n  height: 40px;\n  padding: 0 10px;\n  border: 1px solid #b0b0b0;\n  border-radius: 6px;\n  background-color: #e9ecef; /* Light gray from the diagram */\n  font-family: \"SF Mono\", \"Consolas\", \"Courier New\", monospace;\n  font-size: 1rem;\n}\n\n.main-program-input-container, .main-program-output-container {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  /* This aligns it with the right-hand column */\n  max-width: 50%;\n  margin-left: 50%;\n  padding-right: 3rem;\n  padding-left: 0.5rem; /* Corresponds to half the gap of .step-container */\n  margin-bottom: 1rem;\n  box-sizing: border-box; /* <-- ADD THIS LINE for perfect alignment */\n\n}\n\n.simulation-box {\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  min-height: 100px;\n  border-radius: 8px;\n  border: 2px solid #e83e8c;\n  resize: vertical;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 1rem;\n  overflow-y: auto;\n  background-color: #ffffff;\n}\n\n.variable-tag {\n  background-color: #e9ecef;\n  color: #000000;\n  border-radius: 10px;\n  padding: 6px 12px;\n  margin-bottom: 8px;\n  font-family: \"SF Mono\", \"Consolas\", \"Courier New\", monospace;\n  font-size: 0.95rem;\n  font-weight: bold;\n  width: fit-content;\n  text-align: center;\n  transition: background-color 0.2s ease, border-color 0.2s ease;\n  cursor: pointer;\n}\n\n.variable-tag.selected {\n  background-color: #d1e7fd;\n  border-color: #0d6efd;\n}\n\n.variable-tag:last-child {\n  margin-bottom: 0;\n}\n\n.variable-tag-editor {\n  background-color: white;\n  border: 2px solid #0d6efd;\n  /* Blue border to show it's active */\n  border-radius: 10px;\n  padding: 6px 12px;\n  margin-bottom: 8px;\n  font-family: \"SF Mono\", \"Consolas\", \"Courier New\", monospace;\n  font-size: 0.95rem;\n  width: fit-content;\n  min-width: 160px;\n  /* Give it a minimum width */\n  text-align: center;\n  outline: none;\n}\n\n.chat-box {\n  position: fixed;\n  bottom: 2rem;\n  right: 2rem;\n  width: 550px;\n  height: 600px;\n  background-color: #ddd;\n  border-radius: 10px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  z-index: 1000;\n  resize: both;\n  overflow: auto;\n}\n\n.chat-box.draggable {\n  transform: none;\n}\n\n\n\n.chat-header {\n  padding: 0.75rem 1rem;\n  font-weight: bold;\n  background: linear-gradient(to right, #6a11cb, #2575fc);\n  color: white;\n  border-bottom: none;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n}\n\n.close-chat {\n  font-size: 1.2rem;\n  border: none;\n  background: transparent;\n  color: white;\n  cursor: pointer;\n  margin-left: auto;\n}\n\n.chat-messages {\n  flex: 1;\n  padding: 1rem;\n  padding-bottom: 5rem;\n  /* Add extra space at the bottom */\n  overflow-y: auto;\n  background: #f6f6f6;\n  display: flex;\n  flex-direction: column;\n}\n\n.chat-message {\n  max-width: 75%;\n  padding: 0.6rem 1rem;\n  margin-bottom: 0.6rem;\n  border-radius: 16px;\n  font-size: 0.95rem;\n  line-height: 1.4;\n  word-wrap: break-word;\n}\n\n.chat-message.user {\n  background-color: #6a11cb;\n  color: white;\n  align-self: flex-end;\n  border-bottom-right-radius: 0;\n}\n\n.chat-message.bot {\n  background-color: #f0f0f0;\n  color: #333;\n  align-self: flex-start;\n  border-bottom-left-radius: 0;\n}\n\n.chat-input-container {\n  display: flex;\n  border-top: 1px solid #ccc;\n  padding: 0.5rem;\n  background-color: #fff;\n}\n\n.chat-input {\n  flex: 1;\n  border: 1px solid #ccc;\n  padding: 0.6rem 1rem;\n  font-size: 1rem;\n  border-radius: 6px;\n  margin-right: 0.5rem;\n}\n\n.chat-next-btn, .chat-retry-btn {\n  position: absolute;\n  bottom: 4rem;\n  /* Position it 4rem from the bottom of the chat box */\n  right: 1rem;\n  z-index: 10;\n  /* Ensure it's on top of the messages */\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n\n  /* Visual styles */\n  background-color: #2575fc;\n  color: white;\n  border: none;\n  padding: 0.5rem 0.8rem;\n  font-size: 0.9rem;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.chat-next-btn:hover, .chat-retry-btn:hover {\n  background-color: #138496;\n}\n\n.chat-next-btn:disabled, .chat-retry-btn:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n/* This is the existing rule for the disabled button */\n.refine-btn.disabled,.tests-btn.disabled {\n  background-color: #e9ecef;\n  border-color: #ced4da;\n  color: #6c757d;\n  cursor: not-allowed;\n}\n\n.notification-banner {\n  position: fixed;\n  bottom: 2rem;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 1rem 1.5rem;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  z-index: 2000;\n  font-size: 1rem;\n  border: 1px solid transparent;\n}\n\n.notification-banner.warning {\n  background-color: #fff3cd;\n  border-color: #ffeeba;\n  color: #856404;\n}\n\n.notification-close-btn {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  line-height: 1;\n  cursor: pointer;\n  color: inherit;\n  opacity: 0.7;\n}\n.notification-close-btn:hover {\n  opacity: 1;\n}\n\n.chat-send {\n  background-color: #2575fc;\n  color: white;\n  border: none;\n  padding: 0.6rem 1rem;\n  font-size: 1rem;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n/* .add-step-btn,\n.delete-step-btn {\n  padding: 0.7rem 1.5rem;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  background-color: #007bff; /* Red color */\n  /* color: white;\n}\n\n.add-step-btn,\n.delete-step-btn:hover {\n  background-color: #007bff;\n}\n\n.delete-step-btn:disabled {\n  background-color: #e9ecef;\n  border-color: #ced4da;\n  color: #6c757d;\n  cursor: not-allowed;\n} */ \n\n\n/* .step-container.selected-step {\n  border-color: #000000; /* Blue border to indicate selection */\n  /* box-shadow: 0 0 0 8px rgba(0, 0, 0, 0.25); */\n/* } */ \n\n/* When a step is selected, change the background of the description box */\n/* .step-container.selected .description-box { */\n  /* background-color: #e7f3ff; Light pastel blue */\n  /* border-color: #b3d7ff;      */\n/* } */\n\n/* Also change the background of the simulation box */\n/* .step-container.selected .simulation-box { */\n  /* background-color: #e7f3ff; Light pastel blue */\n  /* border-color: #b3d7ff;     */\n/* } */\n\n.step-container.selected {\n  border-color: #0d6efd; /* A standard red color */\n}\n\n/* New style for correctly verified steps */\n/* --- Verification Status Styles (Corrected) --- */\n\n/* Style for CORRECT steps */\n.step-container.correct .description-wrapper {\n  background-color: #d4edda; /* Light pastel green */\n  border-color: #c3e6cb;\n}\n.step-container.correct .description-box,\n.step-container.correct .trace-area {\n  background-color: transparent; /* Make children transparent */\n}\n\n\n/* Style for INCORRECT steps */\n.step-container.incorrect .description-wrapper {\n  background-color: #f8d7da; /* Light pastel red */\n  border-color: #f5c6cb;\n}\n.step-container.incorrect .description-box,\n.step-container.incorrect .trace-area {\n  background-color: transparent; /* Make children transparent */\n}\n\n/* New style for the green success notification */\n.notification-banner.success {\n  background-color: #d4edda;\n  border-color: #c3e6cb;\n  color: #155724;\n}\n\n/* --- Container for top-left buttons --- */\n/* This new rule handles the sticky behavior */\n.sticky-actions-bar {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  background-color: #f8f9fa;\n  padding: 1rem 0; /* Vertical padding */\n  margin-bottom: 1.5rem; /* Space below the bar */\n  /* box-shadow: 0 2px 8px rgba(0,0,0,0.07); */\n}\n\n/* --- New Iteration Row Styles --- */\n.iteration-rows-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 8px 0; /* Add some vertical padding */\n}\n\n.iteration-row-wrapper {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  margin-bottom: 8px; /* <-- Add this line */\n}\n\n/* This targets the first iteration row and adds a separator below it */\n.iteration-row:first-child {\n  padding-bottom: 12px; /* Space below the row */\n  margin-bottom: 12px;  /* More space */\n  border-bottom: 1px dashed #adb5bd; /* A dashed separator line */\n}\n\n.iteration-row {\n  flex: 1; /* This makes the row of variables take up the available space */\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  /* margin-bottom: 8px; */\n}\n\n/* This adds a separator line between iteration rows */\n.iteration-row-wrapper + .iteration-row-wrapper {\n  border-top: 1px dashed #adb5bd;\n  padding-top: 12px; /* Space after the line, before the next row */\n  margin-top: 12px;  /* More space */\n}\n\n/* This rule just handles the button layout inside the bar */\n.actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  /* We need to constrain the width to match the main content */\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 1rem;\n}\n\n/* --- New styles for the footer bar --- */\n.footer-actions {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background-color: #ffffff;\n  padding: 1rem;\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);\n  display: flex;\n  justify-content: space-between; /* This is the key change */\n  align-items: center;\n  z-index: 1000;\n  padding-bottom: 40px;\n}\n\n.submit-btn {\n\n  /* The original visual styles are kept */\n  background-color: #28a745;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 0.8rem 1.5rem;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15); /* Adds a subtle shadow to lift it off the page */\n}\n\n/* Add these new rules anywhere in App.css */\n.footer-spacer, .footer-center-group, .footer-right-group {\n  flex: 1; /* Each column takes up 1/3 of the space */\n}\n\n.footer-center-group {\n  display: flex;\n  justify-content: center; /* Center the buttons within this column */\n  gap: 1.5rem;\n}\n\n.footer-right-group {\n  display: flex;\n  justify-content: flex-end; /* Push the button to the right of this column */\n  padding-right: 5rem;\n}\n\n.submit-btn:hover {\n  background-color: #218838;\n}\n\n/* --- Confirmation Modal Styles --- */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.6); /* Semi-transparent black background */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2000; /* Ensure it's on top of everything */\n}\n\n.modal-content {\n  background-color: #ffffff;\n  padding: 2rem;\n  border-radius: 8px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  max-width: 450px;\n}\n\n.modal-content h3 {\n  margin-top: 0;\n  font-size: 1.5rem;\n}\n\n.modal-content p {\n  margin-bottom: 2rem;\n  color: #6c757d;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n}\n\n.modal-cancel-btn, .modal-confirm-btn {\n  padding: 0.7rem 1.5rem;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.modal-cancel-btn {\n  background-color: #6c757d;\n  color: white;\n}\n.modal-cancel-btn:hover {\n  background-color: #5a6268;\n}\n\n.description-wrapper {\n  width: 100%;\n  display: flex;\n  flex-direction: column; /* Stack children vertically */\n  border: 2px solid #dee2e6;\n  border-radius: 8px;\n  background-color: #ffffff;\n  overflow: hidden; /* Ensures children stay within the rounded corners */\n}\n\n.step-feedback-banner {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.5rem;\n  background: #ffe8e8;\n  color: #7a1414;\n  border-top: 1px solid #f2b2b2;\n  padding: 0.6rem 0.9rem;\n  font-size: 0.9rem;\n  line-height: 1.4;\n  font-weight: 500;\n}\n\n.step-feedback-text {\n  flex: 1;\n}\n\n.step-container.incorrect .step-feedback-banner {\n  background: #fee2e2;\n}\n\n.feedback-actions {\n  display: inline-flex;\n  gap: 0.35rem;\n  align-items: center;\n}\n\n.feedback-vote-btn {\n  border: none;\n  background: #f8f9fa;\n  border-radius: 6px;\n  padding: 0.25rem 0.5rem;\n  cursor: pointer;\n  font-size: 1.1rem;\n  line-height: 1;\n}\n\n.feedback-vote-btn:hover,\n.feedback-vote-btn:focus-visible {\n  background: #e9ecef;\n}\n\n.feedback-vote-btn.selected.up {\n  background: #d1e7dd;\n  color: #0f5132;\n}\n\n.feedback-vote-btn.selected.down {\n  background: #f8d7da;\n  color: #842029;\n}\n\n.feedback-dismiss-btn {\n  flex-shrink: 0;\n  border: none;\n  background: transparent;\n  color: #7a1414;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0.1rem 0.4rem;\n  line-height: 1;\n  border-radius: 4px;\n}\n\n.feedback-dismiss-btn:hover,\n.feedback-dismiss-btn:focus-visible {\n  background: rgba(0, 0, 0, 0.05);\n  outline: none;\n}\n\n.modal-confirm-btn {\n  background-color: #dc3545; /* Red to indicate a final action */\n  color: white;\n}\n.modal-confirm-btn:hover {\n  background-color: #c82333;\n}\n\n.verify-btn {\n  padding: 0.8rem 1.5rem;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1rem;\n}\n\n/* .add-step-btn:hover {\n  background-color: #c82333;\n} */\n\n.verify-btn {\n  background-color: #28a745;\n  color: white;\n}\n\n.tests-btn,\n.refine-btn {\n  padding: 0.8rem 1.5rem;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1rem;\n  background-color: #28a745;\n  /* teal/blue shade */\n  color: white;\n}\n\n\n.add-var-button {\n  position: absolute;\n  bottom: 12px;\n  right: 12px;\n  width: 32px;\n  height: 32px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  font-size: 20px;\n  line-height: 1;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10;\n}\n\n.delete-var-button:disabled {\n  background-color: #e9ecef;\n  border-color: #ced4da;\n  color: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.add-var-button:hover {\n  background-color: #0056b3;\n}\n\n.delete-var-button {\n  position: absolute;\n  bottom: 12px;\n  left: 12px;\n  width: 32px;\n  height: 32px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  font-size: 20px;\n  line-height: 1;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10;\n}\n\n.delete-var-button:hover {\n  background-color: #007bff;\n}\n\n.simulation-wrapper {\n  width: 50%;\n  position: relative;\n  display: flex;\n  justify-content: center; /* Re-center its content */\n  align-items: center;\n  /* `flex-direction: column` and `gap` are no longer needed here */\n}\n\n.program-input-area {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n/* Style for the \"Input\" text label */\n.program-input-label {\n  font-weight: 500;\n  font-size: 1rem;\n  color: #495057;\n}\n\n/* Style for the new input text box */\n.program-input-box {\n  flex-grow: 1; /* Makes the box fill the remaining width */\n  border: 1px solid #ced4da;\n  border-radius: 6px;\n  padding: 0.5rem 0.75rem;\n  font-family: \"SF Mono\", \"Consolas\", \"Courier New\", monospace;\n  font-size: 1rem;\n  resize: none; /* Disables the user's ability to resize it */\n}\n\n/* --- Loading Spinner Styles --- */\n.loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.7); /* Semi-transparent white background */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 3000; /* Ensure it's on top of everything */\n}\n\n.spinner {\n  width: 60px;\n  height: 60px;\n  border: 8px solid #f3f3f3; /* Light grey circle */\n  border-top: 8px solid #3498db; /* Blue for the spinning part */\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.delete-step-icon-btn.disabled,\n.delete-step-icon-btn:disabled {\n  opacity: 0.4;          /* faded gray */\n  cursor: not-allowed;   /* blocked cursor */\n  pointer-events: none;  /* no clicks */\n}\n\n.disclaimer-footer {\n  position: absolute; /* Position it relative to the .footer-actions */\n  bottom: 6px; /* A small margin from the bottom of the footer */\n  left: 0;\n  width: 100%;\n  color: #6c757d; /* A lighter gray for less emphasis */\n  text-align: center;\n  font-size: 0.75rem;\n  /* font-style: italic; */\n}\n\n.example-footer {\n  display: flex;\n  justify-content: center;\n  margin: 2rem 0;\n}\n\n.example-continue-btn {\n  background-color: #28a745;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  padding: 0.85rem 2.5rem;\n  font-size: 1rem;\n  cursor: pointer;\n}\n\n.example-continue-btn:hover {\n  background-color: #218838;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
